import React from 'react'
import MessageDetails from 'components/libs/message/messageDetails/MessageDetails'

function MessageLogDetails() {
  return <MessageDetails />
}

export default MessageLogDetails
